// ============================================================================
// cattle.batches.forecastDetail — migrated off the global read
// ============================================================================
// Forecast-only batch detail is a live projection, not a persisted processing
// batch. cattle.forecast.bundle provides its complete, fail-closed input set.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'cattle.batches.forecastDetail',
  obligations: Object.freeze([Object.freeze({id: 'cattle.forecast.bundle', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
